import React, { useEffect, useMemo, useState } from "react";
import CardDiv from "modules/common/card-div/CardDiv";
import AllOrderAssign from "modules/order_management/AllOrderAssign";
import { Button } from "react-bootstrap";
import {
  useAllOrderStore,
  useGhostOrdersStore,
} from "modules/order_management/store";
import { useNavigate, useLocation } from "react-router-dom";
import { getLineItemsName, getValue } from "modules/utilities/utility";
import PaginationDiv from "modules/pagination/PaginationDiv";
import GhostOrderTable from "modules/order_management/GhostOrderTable";

function GhostOrders() {
  const {
    medicalData,
    consultData,
    operationData,
    fetchMedicalRep,
    fetchConsultRep,
    fetchOperations,
  } = useAllOrderStore();
  const { ghostOrderData, ghostOrdersLoading, fetchGhostOrdersData } =
    useGhostOrdersStore();
  const [assign, setAssign] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const pageData = searchParams.get("pageNumber");
  const [page, newPage] = useState(1);
  const [assignCount, setAssignCount] = useState(0);

  useEffect(() => {
    fetchMedicalRep();
    fetchConsultRep();
    fetchOperations();
  }, []);

  useEffect(() => {
    fetchGhostOrdersData(pageData);
  }, [pageData]);

  useEffect(() => {
    newPage(Number(pageData));
  }, [pageData]);

  useEffect(() => {
    navigate(`/order-management/ghost-orders?pageNumber=${page}`);
  }, [page]);

  const ghostTableData = useMemo(() => {
    return ghostOrderData?.data?.map(row => ({
    	key: getValue(row, "id"),
    	name: getValue(row, "order_meta.customer.first_name"),
    	phone_Number: getValue(row, "order_phone_number"),
    	order_display_id: getValue(row, "order_display_id"),
    	order_name: getLineItemsName(row.order_meta?.line_items),
    	order_date: getValue(row, "created_at"),
    	assigned_to: getValue(row, "assignment.first_name"),
    	order_type: getValue(row, "order_type"),
    }));
  }, [ghostOrderData]);


  const handleAssign = () => {
    // setAssignCount(assignCount + 1);
  };

  return (
    <CardDiv
      title={
        <div className="d-flex justify-content-between align-items-center">
          <div className="fs-2 ">Ghost Orders</div>
          <div className="d-flex flex-row">
            <AllOrderAssign
              medicalReps={medicalData}
              consultReps={consultData}
              operationsReps={operationData}
              assign={assign}
              setAssign={setAssign}
            />
            <Button className="btn-btn-primary" onClick={handleAssign}>
              Assign
            </Button>
          </div>
        </div>
      }
      component={
        <div>
          <GhostOrderTable
            ghostTableData={ghostTableData}
            isLoading={ghostOrdersLoading}
            assign={assign}
            countAssign={assignCount}
          />

          <div>
            <PaginationDiv
              paginationData={{
                pageCount: ghostOrderData?.pagination?.pageCount
                  ? ghostOrderData?.pagination?.pageCount
                  : 1,
                page: page,
              }}
              newPage={newPage}
            />
          </div>
        </div>
      }
    />
  );
}

export default GhostOrders;
